import Avatar from  './Avatar'
import Calendar from  './Calendar'
import Table from  './Table'
import LinearProgressBar from './LinearProgresBar'

const exportObj = {
    Avatar,
    Calendar,
    Table,
    LinearProgressBar,

}

export default exportObj